import React, { useContext, useRef, useState } from "react";
import Nav from "../../hooks/Nav";
import SecondaryLoader from "../../hooks/SecondaryLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faFileArchive,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import BreadCrumb from "../../tailwindUI/BreadCrumb";
import { AuthContext } from "../../cognito/AuthProvider";
import { Link, useHistory } from "react-router-dom";
import {
  CardItem,
  CardSection,
  CardSectionWrapper,
} from "../../tailwindUI/CardSection";
import { createCampaign } from "../../apiClient/operations/paymentCollectionManagerOperations";
import CSVReader from "react-csv-reader";
import {
  deleteS3,
  uploadS3,
} from "../../apiClient/operations/s3UploadOperations";
import ButtonOrange from "../../tailwindUI/ButtonOrange";
import Button from "../../hooks/Button";
import { AlertContext } from "../../context/AlertContext";
import Table from "../../tailwindUI/Table";

const roadMap = [
  { name: "Campañas", url: "/collecting-manager", current: false },
  {
    name: "Crear Campaña",
    url: "/collecting-manager/create-campaign",
    current: true,
  },
];

export function CreateCampaign() {
  const history = useHistory();
  const { user } = useContext(AuthContext);
  const CSVReaderRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [fileError, setFileError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const { setAlert } = useContext(AlertContext);

  const validateFile = (data, _, originalFile) => {
    setFileError(null);

    if (data.length <= 1) {
      setFileError({ error: "El archivo no contiene información", data: [] });
    }

    if (fileError) return;
    setSelectedFile(originalFile);
    setFileName(`collections/${String(new Date().getTime())}.csv`);
  };

  const uploadAndCreateCampaign = async () => {
    try {
      setIsLoading(true);

      const formData = new FormData();
      formData.set("file", selectedFile, fileName);
      const { Bucket, Key } = await uploadS3(formData);

      const res = await createCampaign({
        bucket: Bucket,
        object_name: Key,
      });

      const data = await res.json();

      if (!res.ok) {
        if (data?.code === "contacts_not_found") {
          setFileError({
            message: "Contactos no encontrados, revisa el archivo csv.",
            data: data?.contacts,
          });
        }
        throw new Error(data?.message || "Error al procesar tu solicitud");
      }
      history.push(`/collecting-manager/view/${data?.data?.campaign_id}`);
    } catch (error) {
      console.log({ error });
      setAlert({
        active: true,
        type: "error",
        message: error?.message || "Error al procesar tu solicitud",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteFile = async () => {
    try {
      CSVReaderRef.current.value = "";
      setSelectedFile(null);
      if (fileError) {
        setIsLoading(true);
        await deleteS3({ name: fileName });
      }
      setFileError(null);
    } catch (error) {
      setAlert({
        active: true,
        type: "error",
        message: "Error al procesar tu solicitud.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <SecondaryLoader />}
      <div className="w-full">
        <Nav user={user}>
          <div className="w-full">
            <Link to="/payment-links">
              <span className="text-2xl text-white font-bold flex items-center cursor-pointer">
                <span className="text-white opacity-50 text-4xl mr-2">
                  <FontAwesomeIcon icon={faArrowLeft} />
                </span>
                <span className="text-lg pr-1">Crear campaña</span>
              </span>
            </Link>
          </div>
        </Nav>
      </div>

      <div className="w-full px-4">
        <div className="w-full mt-20 md:mt-4">
          <BreadCrumb roadMap={roadMap} />
        </div>
        <div className="w-full hidden md:flex text-3xl text-v2-input-text font-bold mt-5 justify-between">
          <a>
            <FontAwesomeIcon
              className="cursor-pointer"
              icon={faArrowLeft}
              onClick={() => history.goBack()}
            />
          </a>
          <span className="pl-4 w-full">Crear campaña</span>
        </div>
        <div className={`w-full px-4 py-0 md:py-4 mb-16 lg:mb-8`}>
          <CardSectionWrapper>
            <CardSection
              title="Subir documento"
              footer={
                <Button
                  disabled={!selectedFile || fileError}
                  heigth="h-12"
                  bg="bg-v2-blue-text-login"
                  onClick={uploadAndCreateCampaign}
                >
                  Crear campaña
                </Button>
              }
            >
              <CardItem>
                <CSVReader
                  onFileLoaded={validateFile}
                  ref={CSVReaderRef}
                  cssClass="hidden"
                />
                {selectedFile ? (
                  <>
                    <div className="flex">
                      <div className="flex items-center flex-1">
                        <FontAwesomeIcon
                          icon={faFileArchive}
                          className="text-v2-gray-light-plus-circle text-3xl leading-3 "
                        />
                        <span className="text-v2-text-bar-steps text-[15px] pl-4">
                          {selectedFile.name}
                        </span>
                      </div>
                      <div className="flex justify-end text-v2-yellow-edit-info">
                        <FontAwesomeIcon
                          icon={faTrash}
                          className="leading-3 text-2xl cursor-pointer"
                          onClick={handleDeleteFile}
                        />
                      </div>
                    </div>
                    {fileError?.message && (
                      <div className="text-v2-red-error-message mt-4">
                        <p className="pt-0.5 font-semibold text-sm mb-2">
                          {fileError?.message}
                        </p>
                        <Table
                          columns={[
                            { heading: "Nombre", value: "name" },
                            { heading: "Email", value: "email" },
                          ]}
                          data={fileError?.data}
                        />
                        {/* <ul className="space-y-2 text-sm">
                          {fileError?.data?.map((item, index) => (
                            <li
                              key={`${index}-${item?.email}`}
                              className="flex flex-col"
                            >
                              <p className="flex items-center gap-2">
                                <span className="h-1 w-1 inline-block rounded-full bg-v2-red-error-message" />
                                Nombre: {item?.name}
                              </p>
                              <p className="pl-3">Email: {item?.email}</p>
                            </li>
                          ))}
                        </ul> */}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="flex flex-col gap-1">
                    <label
                      htmlFor="email"
                      className="text-base text-v2-input-text"
                    >
                      Seleccionar csv
                    </label>
                    <div className="w-full sm:w-1/2">
                      <ButtonOrange
                        isFullWidth={true}
                        onClick={() => CSVReaderRef.current.click()}
                      >
                        Subir CSV
                      </ButtonOrange>
                    </div>
                  </div>
                )}
              </CardItem>
            </CardSection>
          </CardSectionWrapper>
        </div>
      </div>
    </>
  );
}
